module.exports = __webpack_public_path__ + "img/treatment-based-options-desktop-ru.776eb92b.jpg";